import Pusher from "pusher-js";

export const pusher =   new Pusher("5a8f542f7e4c1f452d53", { cluster: "ap2", forceTLS: true });
